import { useCallback, useEffect, useState } from "react";
import Analytics from "../../../Settings/components/integration/assets/Analytics.png";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import env from "../../../../config/env"
import { useUserInfo } from "../../../../context/user";
import { useUsersContext } from "../../../../context/usersContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Icons from "../../../../components/icons/index"

const IntegrationCard = ({ integration }) => {
    const [waiting, setWaiting] = useState(false);
    const [error, setError] = useState(null);
    const [connectedInt, setConnectedInt] = useState([]);
    const [loadingProvider, setLoadingProvider] = useState(null);
    const [confirmDisconnect, setConfrimDisconnect] = useState(false);
    const [disconnectProvider, setDisconnectProvider] = useState({});
    const [disconnecting, setDisconnecting] = useState(false);
    const BASE_URL = `${env.API_URL}/v1`;
    const userActiveLocation = useUserInfo()[4];
    const userInfo = useUserInfo()[0];
    const [toast, setToast] = useState({ message: '', subMessage: '', visible: false, })

    const currentURL = window.location.href;
    const urlObject = new URL(currentURL);
    const domain = urlObject.hostname;

    const fetchIntegrations = async () => {
        setWaiting(true);
        try {
            const response = await axios.get(
                `${BASE_URL}/integrations/available?location_id=${userActiveLocation?.id}&user_id=${userInfo?.userId}`
            );
            setConnectedInt(response?.data?.connected || []);
            setWaiting(false);
        } catch (error) {
            console.error("Failed to fetch integrations:", error);
            setError("Failed to fetch integrations.");
        }
    };

    useEffect(() => {
        fetchIntegrations();
    }, []);


    let connectionInterval = null;
    const checkConnection = async () => {
        const response = await axios.get(
            `${BASE_URL}/accounts/location?id=${userActiveLocation?.id}`
        );
        if (response?.data?.data?.nango_connected) {
            clearInterval(connectionInterval);
            setLoadingProvider(null);
            fetchIntegrations();
        }
    };

    const launchOAuthPopup = (integration) => {
        setLoadingProvider(integration);
        setError(null);
        const width = 500;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        const testParams = new URLSearchParams({
            profile_id: userActiveLocation?.id,
            user_id: userInfo?.userId,
            agency_id: userActiveLocation?.agency_id,
            provider: integration.provider,
            ...(integration?.integration_id ? { integration_id: integration.integration_id } : {}),
        });

        window.open(
            `${env.NANGO_API_URL}init?${testParams.toString()}`,
            "OAuth Login",
            `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no`
        );

        connectionInterval = setInterval(() => {
            checkConnection();
        }, 4000);
    };

    const handleDisconnection = async () => {
        setDisconnecting(true);
        try {
            const response = await axios.post(
                `${BASE_URL}/integrations/disconnect?profile_id=${userActiveLocation?.id}&provider=${disconnectProvider?.provider}&user_id=${userInfo?.userId}${disconnectProvider?.integration_id ? `&integration_id=${disconnectProvider?.integration_id}` : ''}`
            );
            setDisconnectProvider({});
            setDisconnecting(false);
            setConfrimDisconnect(false);
            fetchIntegrations();
        } catch (error) {
            console.error("Failed to fetch integrations:", error);
            setError("Failed to fetch integrations.");
        }
    };

    const getConnectedIntegration = useCallback((integration) => {
        const connected = connectedInt.find((item) => item.provider === integration?.provider);
        if (integration?.integration_id && connected && integration?.integration_id === connected?.integration_id) {
            return connected
        }
        if (!integration?.integration_id && connected) {
            return connected
        }
        return null
    }, [connectedInt, integration]);

    return (
        <div
            className="w-[320px] h-[326px] !border-[#D9D9D9] rounded border mr-4 mb-4 p-7 "
            key={integration.provider}
        >
            {/* <div className="flex flex-col justify-between h-full">
                {getConnectedIntegration(integration?.provider)
                    ?.provider === integration?.provider ? (
                    <div className="py-[5px] test-[12px] px-4 w-fit h-fit rounded-full bg-[#CFF7D3] ml-auto">
                        Connected
                    </div>
                ) : (
                    <div className="py-[5px] test-[12px] px-4 w-fit h-fit rounded-full bg-[#E6E6E6] text-[#757575] ml-auto">
                        Disconnected
                    </div>
                )}
                <div className="flex items-center gap-2">
                    <div className="border rounded !border-[#D9D9D9] w-[50px] h-[50px] flex items-center justify-center">
                        <img
                            src={
                                integration?.provider === "google-analytics"
                                    ? Analytics
                                    : integration?.provider?.toLowerCase() ===
                                        "fireflies"
                                        ? `https://www.google.com/s2/favicons?sz=64&domain_url=fireflies.ai`
                                        : integration?.provider?.toLowerCase() ===
                                            "roller"
                                            ? `https://www.google.com/s2/favicons?sz=64&domain_url=https://mysupport.roller.software/`
                                            : integration?.provider?.toLowerCase() ===
                                                "google-ads"
                                                ? `https://www.google.com/s2/favicons?sz=64&domain_url=ads.google.com`
                                                : integration?.provider?.toLowerCase() ===
                                                    "facebook"
                                                    ? `https://www.google.com/s2/favicons?sz=64&domain_url=meta.com`
                                                    : `https://www.google.com/s2/favicons?sz=64&domain_url=${integration?.provider
                                                        ?.split("-")?.[0]
                                                        ?.toLowerCase()}.com`
                            }
                            alt={integration?.display_name}
                            className="w-[30px] h-[30px]"
                        />
                    </div>

                    <div className="text-[22px] font-bold text-wrap">
                        {integration?.provider?.toLowerCase() === "facebook"
                            ? "Meta"
                            : integration?.display_name?.length > 15
                                ? integration.display_name.slice(0, 15) + "..."
                                : integration?.display_name}
                    </div>
                </div>

                <div className="font-normal">
                    <div className="h-fit flex items-center">
                        <h2
                            className=" block leading-[140%]"
                            style={{ fontSize: "20px" }}
                        >
                            Connect
                            {getConnectedIntegration(integration?.provider)
                                ?.provider === integration?.provider
                                ? "ed"
                                : ""}{" "}
                            to{" "}
                            {integration.provider === "google-drive"
                                ? " Google (Docs, Sheets, Slides)"
                                : integration?.provider?.toLowerCase() ===
                                    "facebook"
                                    ? "Meta"
                                    : integration.display_name}
                        </h2>
                    </div>
                    {integration?.article_url && (
                        <a
                            href={integration.article_url}
                            target="_blank"
                            rel="noreferrer"
                            underline="none"
                            style={{
                                fontSize: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                            }}
                        >
                            <span style={{ color: "#b1b1b1" }}>Learn more</span>
                            <OpenInNewIcon
                                fontSize="inherit"
                                sx={{ color: "#b1b1b1" }}
                            />
                        </a>
                    )}
                </div>
                <div className="flex flex-col">
                    {getConnectedIntegration(integration?.provider)
                        ?.provider === integration?.provider ? (
                        <div className="flex items-center gap-2 font-normal text-[12px]">
                            <span className="w-[10px] h-[10px] rounded-full bg-[#CFF7D3]"></span>
                            <strong style={{ textTransform: "capitalize" }}>
                                {getConnectedIntegration(integration?.provider)
                                    ?.userName !== null
                                    ? getConnectedIntegration(integration?.provider)
                                        ?.userName
                                    : ""}
                            </strong>
                        </div>
                    ) : (
                        <div className="flex items-center gap-2 !font-normal text-[12px]">
                            <span className="w-[10px] h-[10px] rounded-full bg-[#FDD3D0]"></span>
                            <strong style={{ textTransform: "capitalize" }}>
                                No Account found
                            </strong>
                        </div>
                    )}

                    <div className="flex  mt-5 w-full self-end">
                        <div
                            key={integration.provider}
                            style={{ marginBottom: "10px" }}
                        >
                            {getConnectedIntegration(integration?.provider)
                                ?.provider === integration?.provider ? (
                                <button
                                    onClick={() => {
                                        setConfrimDisconnect(true);
                                        setDisconnectProvider({
                                            provider: integration.provider,
                                            name: integration?.display_name,
                                        });
                                    }}
                                    className="px-10 py-2 text-xs  !border-[#D9D9D9] w-[260px] h-[42px] rounded border  uppercase font-bold"
                                >
                                    {loadingProvider?.provider === integration.provider
                                        ? `Disconnecting to ${integration.display_name}...`
                                        : `Disconnect`}
                                </button>
                            ) : (
                                <button
                                    onClick={() =>
                                        launchOAuthPopup(integration)
                                    }
                                    disabled={
                                        loadingProvider === integration.provider
                                            ? true
                                            : false
                                    }
                                    className="px-10 py-2 text-xs bg-[#1E1E1E] w-[260px] h-[42px] rounded text-white uppercase font-bold"
                                >
                                    {loadingProvider === integration.provider
                                        ? `Connecting to ${integration.display_name}...`
                                        : `Connect`}
                                </button>
                            )}
                        </div>
                        {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                </div>
            </div> */}
            <div className="flex flex-col justify-between h-full">
                {getConnectedIntegration(integration)
                    ?.provider === integration?.provider ? (
                    <div className="py-[5px] test-[12px] px-4 w-fit h-fit rounded-full bg-[#CFF7D3] ml-auto">
                        Connected
                    </div>
                ) : (
                    <div className="py-[5px] test-[12px] px-4 w-fit h-fit rounded-full bg-[#E6E6E6] text-[#757575] ml-auto">
                        Disconnected
                    </div>
                )}
                <div className="flex items-center gap-2">
                    <div className="border rounded !border-[#D9D9D9] w-[50px] h-[50px] flex items-center justify-center">
                        <img
                            src={
                                integration?.provider === "google-analytics"
                                    ? Analytics
                                    : integration?.provider?.toLowerCase() ===
                                        "fireflies"
                                        ? `https://www.google.com/s2/favicons?sz=64&domain_url=fireflies.ai`
                                        : integration?.provider?.toLowerCase() ===
                                            "roller"
                                            ? `https://www.google.com/s2/favicons?sz=64&domain_url=https://mysupport.roller.software/`
                                            : integration?.provider?.toLowerCase() ===
                                                "google-ads"
                                                ? `https://www.google.com/s2/favicons?sz=64&domain_url=ads.google.com`
                                                : integration?.provider?.toLowerCase() ===
                                                    "facebook"
                                                    ? `https://www.google.com/s2/favicons?sz=64&domain_url=meta.com`
                                                    : `https://www.google.com/s2/favicons?sz=64&domain_url=${integration?.provider
                                                        ?.split("-")?.[0]
                                                        ?.toLowerCase()}.com`
                            }
                            alt={integration?.display_name}
                            className="w-[30px] h-[30px]"
                        />
                    </div>

                    <div className="text-[22px] font-bold text-wrap">
                        {integration?.provider?.toLowerCase() === "facebook"
                            ? "Meta"
                            : integration?.display_name?.length > 15
                                ? integration.display_name.slice(0, 15) + "..."
                                : integration?.display_name}
                    </div>
                </div>

                <div className="font-normal">
                    <div className="h-fit flex items-center">
                        <h2
                            className=" block leading-[140%]"
                            style={{ fontSize: "20px" }}
                        >
                            Connect
                            {getConnectedIntegration(integration)
                                ?.provider === integration?.provider
                                ? "ed"
                                : ""}{" "}
                            to{" "}
                            {integration.provider === "google-drive"
                                ? " Google (Docs, Sheets, Slides)"
                                : integration?.provider?.toLowerCase() ===
                                    "facebook"
                                    ? "Meta"
                                    : integration.display_name}
                        </h2>
                    </div>
                    {integration?.article_url && (
                        <a
                            href={integration.article_url}
                            target="_blank"
                            rel="noreferrer"
                            underline="none"
                            style={{
                                fontSize: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                            }}
                        >
                            <span style={{ color: "#b1b1b1" }}>Learn more</span>
                            <OpenInNewIcon
                                fontSize="inherit"
                                sx={{ color: "#b1b1b1" }}
                            />
                        </a>
                    )}
                </div>
                <div className="flex flex-col">
                    {getConnectedIntegration(integration)
                        ?.provider === integration?.provider ? (
                        <div className="flex items-center gap-2 font-normal text-[12px]">
                            <span className="w-[10px] h-[10px] rounded-full bg-[#CFF7D3]"></span>
                            <strong style={{ textTransform: "capitalize" }}>
                                {getConnectedIntegration(integration)
                                    ?.userName !== null
                                    ? getConnectedIntegration(integration)
                                        ?.userName
                                    : ""}
                            </strong>
                        </div>
                    ) : (
                        <div className="flex items-center gap-2 !font-normal text-[12px]">
                            <span className="w-[10px] h-[10px] rounded-full bg-[#FDD3D0]"></span>
                            <strong style={{ textTransform: "capitalize" }}>
                                No Account found
                            </strong>
                        </div>
                    )}

                    <div className="flex  mt-5 w-full self-end">
                        <div
                            key={integration.provider}
                            style={{ marginBottom: "10px" }}
                        >
                            {getConnectedIntegration(integration)
                                ?.provider === integration?.provider ? (
                                <button
                                    onClick={() => {
                                        setConfrimDisconnect(true);
                                        setDisconnectProvider({
                                            provider: integration.provider,
                                            name: integration?.display_name,
                                            integration_id: integration?.integration_id,
                                        });
                                    }}
                                    className="px-10 py-2 text-xs  !border-[#D9D9D9] w-[260px] h-[42px] rounded border  uppercase font-bold"
                                >
                                    {(loadingProvider?.integration_id && loadingProvider?.integration_id === integration?.integration_id && loadingProvider?.provider === integration.provider) || (!loadingProvider?.integration_id && loadingProvider?.provider === integration?.provider)
                                        ? `Disconnecting to ${integration.display_name}...`
                                        : `Disconnect`}
                                </button>
                            ) : (
                                <button
                                    onClick={() =>
                                        launchOAuthPopup(integration)
                                    }
                                    disabled={
                                        (loadingProvider?.integration_id && loadingProvider?.integration_id === integration?.integration_id && loadingProvider?.provider === integration.provider) || (!loadingProvider?.integration_id && loadingProvider?.provider === integration?.provider)
                                            ? true
                                            : false
                                    }
                                    className="px-10 py-2 text-xs bg-[#1E1E1E] w-[260px] h-[42px] rounded text-white uppercase font-bold"
                                >
                                    {(loadingProvider?.integration_id && loadingProvider?.integration_id === integration?.integration_id && loadingProvider?.provider === integration.provider) || (!loadingProvider?.integration_id && loadingProvider?.provider === integration?.provider)
                                        ? `Connecting to ${integration.display_name}...`
                                        : `Connect`}
                                </button>
                            )}
                        </div>
                        {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                </div>
            </div>
            {confirmDisconnect && (
                <div className="modal-zz" onClick={() => setConfrimDisconnect(true)}>
                    <div
                        className="modal-content-zz position-relative"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div>
                            <h2 className="text-xl font-bold">
                                Do you really want to disconnect {disconnectProvider?.name}?
                            </h2>
                        </div>
                        <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
                            <button
                                onClick={() => setConfrimDisconnect(false)}
                                aria-label="Send message"
                                disabled={disconnecting}
                                className="px-10 py-2 text-xs bg-red-800 text-white rounded-md uppercase font-bold"
                                style={{
                                    backgroundColor: "#4D4D4D",
                                    color: "#fff",
                                    width: "100%",
                                    maxWidth: "300px",
                                    textAlign: "center",
                                }}
                            >
                                <div className="hover-text">Cancel</div>
                            </button>

                            <button
                                onClick={handleDisconnection}
                                className="px-10 py-2 text-xs bg-red-800 text-white rounded-md uppercase font-bold"
                                style={{
                                    width: "100%",
                                    maxWidth: "300px",
                                    textAlign: "center",
                                }}
                                disabled={disconnecting}
                            >
                                {disconnecting && (
                                    <Icons
                                        id="spinner"
                                        color="white"
                                        style={{ verticalAlign: "text-top", marginRight: "10px" }}
                                    />
                                )}
                                Disconnect
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>

    )
}

export default IntegrationCard